import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const AI_PHRASES = [
  { main: 'Scanning influencer profiles', sub: 'Powered by AI matching engine' },
  { main: 'Analysing engagement signals', sub: 'Cross-referencing platform metrics' },
  { main: 'Matching AI criteria', sub: 'Running prediction models' },
  { main: 'Fetching audience data', sub: 'Evaluating brand fit' },
  { main: 'Ranking by relevance', sub: 'Almost ready…' },
];

const AiLoader = () => {
  const [phraseIdx, setPhraseIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setPhraseIdx((i) => (i + 1) % AI_PHRASES.length), 2000);
    return () => clearInterval(t);
  }, []);

  const { main, sub } = AI_PHRASES[phraseIdx];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 5, gap: 2 }}>
    <Box sx={{ position: 'relative', width: 56, height: 56 }}>
    <CircularProgress
        size={56}
        thickness={1.5}
        sx={{ position: 'absolute', color: 'primary.light', opacity: 0.3 }}
        variant="determinate"
        value={100}
    />
    <CircularProgress
        size={56}
        thickness={1.5}
        sx={{ position: 'absolute', color: 'primary.main' }}
    />
    {/* Filled circle background */}
    <Box
        sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 38,
        height: 38,
        borderRadius: '50%',
        bgcolor: 'primary.main',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        }}
    >
        <AutoAwesomeIcon sx={{ color: '#fff', fontSize: 20 }} />
    </Box>
    </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Typography fontWeight={500} fontSize="0.9rem" sx={{ transition: 'all 0.4s ease' }}>
          {main}
        </Typography>
        <Typography fontSize="0.75rem" color="text.secondary" sx={{ mt: 0.5 }}>
          {sub}
        </Typography>
      </Box>
      <Stack direction="row" spacing={0.5}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              bgcolor: 'primary.main',
              animation: 'pulse 1.4s infinite ease-in-out',
              animationDelay: `${i * 0.2}s`,
              '@keyframes pulse': {
                '0%, 80%, 100%': { opacity: 0.2, transform: 'scale(0.8)' },
                '40%': { opacity: 1, transform: 'scale(1)' },
              },
            }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default AiLoader;